// extracted by mini-css-extract-plugin
export default {"wrapper":"standards_wrapper__cJsKP","inside":"standards_inside__qwlAU","links":"standards_links__6jm4e"};